import { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { setStoredUrlParams } from '@/service/api';
import routePath from '@/routes/route-path';

const SessionInitializer: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const [ initialized, setInitialized ] = useState(false);

    useEffect(() => {
        const init = () => {
            if (initialized) return;

            // 提取所有 URL 参数并存储
            const searchParams = new URLSearchParams(location.search);
            const allParams: Record<string, string> = {};
            searchParams.forEach((value, key) => {
                allParams[key] = value;
            });

            if (Object.keys(allParams).length > 0) {
                setStoredUrlParams(allParams);
                // 保留旧的 SN-only 存储，getStoredSerialNumber 仍依赖
                if (allParams.SN) {
                    localStorage.setItem('url_data_param', allParams.SN);
                }
            }

            // 不再在此处调用 session/create，由 Home 页地区选择完成后触发
            setInitialized(true);

            if (location.pathname !== routePath.home) {
                navigate(routePath.home, { replace: true });
            }
        };

        init();
    }, [ navigate, location.search, location.pathname, initialized ]);

    // 仅在首屏初始化期间显示加载
    if (!initialized) {
        return (
            <div style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100dvh',
                fontSize: '16px',
                color: '#666'
            }}
            >
                Initializing...
            </div>
        );
    }

    return <>{children}</>;
};

export default SessionInitializer;
